// i18n area 'common' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.uk-UA.meta.json.
import type { enUS } from './common'

export const ukUA: typeof enUS = {
  nav: {
    home: 'Головна',
    vms: 'Віртуальні машини',
    templates: 'Шаблони',
    importVms: 'Імпорт ВМ',
    containers: 'Контейнери',
    containersApps: 'Застосунки',
    containersPods: 'Поди',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Образи OCI',
    containersOciRegistries: 'Реєстри OCI',
    containersCtTemplates: 'Шаблони CT',
    networkServices: 'Мережеві служби',
    firewall: 'Брандмауер',
    checkpoints: 'Контрольні точки',
    backup: 'Резервне копіювання',
    monitoring: 'Моніторинг',
    cluster: 'Кластер',
    clusterSettings: 'Глобальні налаштування',
    clusterNodes: 'Вузли',
    clusterDevices: 'Ресурси USB та PCIe',
    clusterFederation: 'Федерація',
    network: 'Мережа',
    overlayNetworks: 'Оверлейні мережі',
    fabric: 'Фабрика',
    ipam: 'IPAM',
    storage: 'Сховище',
    data: 'Дані',
    storages: 'Сховища',
    hci: 'Гіперконвергенція',
    ceph: 'Ceph',
    system: 'Система',
    tasks: 'Завдання',
    events: 'Події',
    audit: 'Аудит',
    diagnostics: 'Діагностика',
    notifications: 'Сповіщення',
    proximity: 'TVirt Proximity',
    users: 'Користувачі та групи',
    groups: 'Групи',
    mfa: 'MFA',
    realms: 'Реалми та SSO',
    rbac: 'Ролі та дозволи',
    credentials: 'Облікові дані',
    scopes: 'Скоупи',
    tags: 'Теги',
    explorer: 'Оглядач',
    licensing: 'Ліцензія',
    information: 'Відомості'
  },
  mode: {
    light: 'Світла',
    dark: 'Темна',
    system: 'Системна',
    tooltip: 'Тема'
  },
  language: {
    tooltip: 'Мова'
  },
  langRegion: {
    europe: 'Європа',
    northAmerica: 'Північна Америка',
    southAmerica: 'Південна Америка',
    asia: 'Азія'
  },
  notFound: {
    title: 'Сторінку не знайдено',
    body: 'Ця адреса не відповідає жодній сторінці TVirt — сторінка могла переїхати після оновлення, або посилання застаріле.',
    backHome: 'Повернутися на головну'
  },
  scopeBrowser: {
    title: 'Скоупи',
    all: 'Увесь кластер',
    noChildren: 'Тут немає вкладених скоупів',
    recursive: 'Включати нащадків',
    collapse: 'Згорнути панель скоупів',
    openPicker: 'Переглянути скоупи',
    up: 'На рівень вище',
    countTooltip: '{direct} у цьому скоупі · {total} разом із нащадками'
  },
  search: {
    tooltip: 'Пошук (⌘K)',
    placeholder: 'Шукати ВМ, мережі, сховища…',
    empty: 'Нічого не знайдено',
    groups: {
      recent: 'Недавні',
      shortcuts: 'Ярлики',
      actions: 'Дії',
      goTo: 'Перейти до'
    },
    kind: {
      catalog: 'Каталог',
      scope: 'Скоуп',
      node: 'Вузол'
    },
    footer: {
      navigate: 'навігація',
      open: 'відкрити',
      close: 'закрити'
    },
    actions: {
      createVm: 'Створити ВМ…',
      uploadIso: 'Завантажити ISO…',
      clusterSettings: 'Налаштування кластера',
      consoleOf: 'Перейти до консолі {name}'
    }
  },
  stub: {
    containersSummary: 'Застосунки та системні контейнери (CT) з їхніми образами OCI, реєстрами та шаблонами — керовані поруч із вашими ВМ.',
    sectionSummary_vms: 'Віртуальні машини та їхні шаблони — життєвий цикл, знімки, міграція та консоль.',
    sectionSummary_storages: 'Сховища, де живуть диски, образи та метадані ВМ.',
    sectionSummary_catalogs: 'Дім файлових артефактів кластера: образи ISO, шаблони CT і ВМ та архіви OCI, упорядковані в каталогах.',
    sectionSummary_overlay: 'Оверлейні мережі VXLAN між вузлами кластера.',
    sectionSummary_fabric: 'Інвентар фізичної мережі — комутатори, порти, LAGG і логічні мережі.',
    sectionSummary_ipam: 'Адресація, похідна від мереж фабрики та оверлею: хто тримає кожну адресу.',
    sectionSummary_services: 'Сервери DHCP і DNS, похідні від мережевого реєстру.',
    sectionSummary_ceph: 'Кластери Ceph, керовані на вузлах TVirt.',
    sectionSummary_hci: 'Гіперконвергентні технології сховища на вузлах TVirt.',
    sectionSummary_cluster: 'Вузли, членство та налаштування кластера.',
    containers: 'Системні контейнери — у дорожній карті; цей розділ їх прийме.',
    containersApps: 'Контейнеризовані застосунки — у дорожній карті; ця область їх прийме.',
    containersPods: 'Поди групують контейнери зі спільною мережею й томами — екземпляри і є застосунками.',
    containersCt: 'Системні контейнери (CT) — у дорожній карті; ця область їх прийме.',
    multiscsi: 'TVStor MultiSCSI — у дорожній карті; ця область його прийме.',
    clusterFederation: 'Федерація між кластерами TVirt — у дорожній карті; ця область її прийме.',
    containersOciImages: 'Образи OCI — у дорожній карті; ця область їх прийме.',
    containersOciRegistries: 'Реєстри OCI — у дорожній карті; ця область їх прийме.',
    containersCtTemplates: 'Шаблони CT — у дорожній карті; ця область їх прийме.',
    importVms: 'Тут з’являться імпортери ESXi та Proxmox: конвертація гостьових систем і масова міграція всередину TVirt.',
    backup: 'Вбудоване резервне копіювання прийде з версією 6.2: дедупліковані content-addressed репозиторії, інкрементальні копії на базі CBT, вікна незмінності та реплікація між репозиторіями.',
    monitoring: 'Загальнокластерні дашборди конкуренції за ресурси (cpu.ready, тиск PSI, вбудовані сповіщення) вже в дорозі — сьогодні ті самі метрики живуть у деталях кожної ВМ.'
  },
  home: {
    welcome: 'Ви увійшли під обліковим записом: {name}',
    subtitle: 'Ось ваш кластер TVirt з першого погляду.',
    loadError: 'Не вдалося завантажити огляд — чи доступний бекенд TVirt?',
    health: {
      ok: 'Усе гаразд',
      warning: 'Увага',
      critical: 'Критичні проблеми'
    },
    reason: {
      'node-down': '{subject} вимкнено',
      'node-stale': '{subject} давно не озивається',
      'node-maintenance': '{subject} на обслуговуванні',
      'tasks-failed': {
        one: '{n} завдання завершилося помилкою за останні 24 год',
        few: '{n} завдання завершилися помилкою за останні 24 год',
        many: '{n} завдань завершилися помилкою за останні 24 год',
        other: '{n} завдання завершилося помилкою за останні 24 год'
      },
      'storage-degraded': 'сховище {subject} у деградованому стані',
      'storage-error': 'сховище {subject} у стані помилки',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'сховище конфігурації кластера недоступне',
      'license-absent': 'ліцензії немає — нові ВМ не запустяться',
      'license-expired': 'термін дії ліцензії минув — нові ВМ не запустяться',
      'license-exceeded': 'ліміт ліцензії перевищено — нові ВМ не запустяться',
      'failover-reserve-eroded': 'резерв відмовостійкості майже вичерпано',
      'failover-reserve-exhausted': 'резерв відмовостійкості вичерпано — нові ВМ не запустяться',

      'oci-cache-nearly-full': 'кеш OCI на {subject} майже заповнений — дайджести вилучають вручну',
      'oci-cache-full': 'кеш OCI на {subject} заповнений — жоден pull не вдасться, доки не вилучити дайджести',
      'config-replica-empty': 'репліка конфігурації на {subject} ПОРОЖНЯ — вузол не має конфігурації кластера, доки реплікація не вдасться',
      'config-replica-stalled': 'реплікація конфігурації на {subject} зупинилася — локальна копія відстає від конфігурації кластера'
    },
    staleChip: 'Дані застаріли',
    staleAsOf: 'остання реплікація {time}',
    zone: {
      nodes: 'Вузли',
      failoverReserve: 'Резерв відмовостійкості',
      capacity: 'Ємність',
      workload: 'Робоче навантаження',
      protection: 'Захист',
      activity: 'Нещодавня активність'
    },

    // Зона резерву відмовостійкості (контроль допуску N+1, завдання #133b).
    reserve: {
      state: {
        ok: 'Резерв у нормі',
        eroded: 'Резерв майже вичерпано',
        exhausted: 'Резерв вичерпано',
        unknown: 'Резерв невідомий'
      },
      tolerate: {
        one: 'витримує втрату {n} вузла',
        few: 'витримує втрату {n} вузлів',
        many: 'витримує втрату {n} вузлів',
        other: 'витримує втрату {n} вузла'
      },
      usedOf: '{used} / {allowed} GiB використано',
      keepFree: '{n} GiB тримаються вільними на випадок відмови',
      expendable: 'з них {n} жертовних у роботі',
      headroom: 'ще можна запустити {n} GiB',
      short: 'резерву бракує {n} GiB — нові ВМ не запустяться',
      hp: {
        usedOf: 'Сторінки по {size} — використано: {used} / {allowed}',
        keepFree: 'тримаються вільними на випадок відмови: {keep}',
        headroom: 'ще можна запустити: {n}',
        short: 'резерву бракує: {n} — нові ВМ з величезними сторінками не запустяться'
      },
      worstCase: 'найгірший випадок: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Жоден вузол ще не повідомив свій обсяг пам’яті — резерв неможливо обчислити, і жоден запуск не відхиляється.',
      reason: {
        attestedDown: 'засвідчено вимкнений',
        maintenance: 'на обслуговуванні',
        unreachable: 'недоступний',
        capacityUnknown: 'пам’ять не задекларована'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} ядер / {threads} потоків',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} активна ВМ',
        few: '{n} активні ВМ',
        many: '{n} активних ВМ',
        other: '{n} активної ВМ'
      },
      activeVmsUnknown: 'активні ВМ невідомі',
      lastSeen: 'востаннє на зв’язку {time}',
      neverSeen: 'ніколи не був на зв’язку',
      down: 'Вимкнений',
      maintenance: 'Обслуговування',
      stale: 'Недоступний'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB виділено',
      reserve: 'резерв {n} GiB',
      unobserved: 'ємність ще не спостерігалася',
      empty: 'Сховищ поки що немає'
    },
    workload: {
      vms: 'Віртуальні машини',
      apps: 'Застосунки',
      services: 'Мережеві служби',
      empty: 'Поки що нічого',
      phasesUnknown: 'розподіл за фазами недоступний'
    },
    protection: {
      none: 'Не налаштовано жодної цілі резервного копіювання — захистіть свою конфігурацію.',
      configure: 'Налаштувати контрольні точки',
      noRuns: 'Жодної контрольної точки ще не створено.',
      last: 'Остання контрольна точка',
      onTarget: 'на {target}',
      viewAll: 'Контрольні точки'
    },
    activity: {
      empty: 'Нещодавньої активності немає',
      failed24: {
        one: '{n} з помилкою за 24 год',
        few: '{n} з помилкою за 24 год',
        many: '{n} з помилкою за 24 год',
        other: '{n} з помилкою за 24 год'
      },
      viewAll: 'Переглянути всі завдання'
    }
  },
  notes: {
    title: 'Нотатки',
    tabEdit: 'Редагувати',
    tabPreview: 'Попередній перегляд',
    placeholder: 'Вільні нотатки оператора — Markdown відображається у попередньому перегляді',
    empty: 'Нотаток немає',
    tooLarge: 'Нотатки перевищують ліміт 64 KiB',
    saveError: 'Не вдалося зберегти нотатки'
  },
  common: {
    contractError: 'Відповідь бекенду містить значення, невідоме цьому інтерфейсу: {field}={value} — онови вебінтерфейс до версії бекенду.',
    contractErrorItems: '{count} обʼєктів цього списку цей інтерфейс не може прочитати ({field}={value}), і вони не показані.',
    staleHint: 'Сховище конфігурації недоступне — це репліка конфігурації цього вузла; стан флоту невідомий.',
    staleStateAge: 'стан на {time}',
    staleStateNever: 'стан жодного разу не отримано зі сховища: ви бачите лише спостереження цього вузла',
    staleStateTooltip: 'Сховище кластера недоступне: спостережуваний стан (фаза, вузол, агент) береться з репліки стану цього вузла і відповідає останньому успішному читанню зі сховища — він може бути застарілим.',
    noPermission: 'У вас немає дозволу на цю дію',
    actionStillRunning: 'Дія ще виконується — результат поки невідомий',
    staleWrite: "Хтось інший змінив цей об'єкт, поки ви його редагували — нічого не записано. Перезавантажте та повторіть зміну на актуальному стані.",
    staleReload: 'Перезавантажити',
    preview: 'Попередній перегляд',
    previewTitle: 'Попередній перегляд результату',
    previewNothingWritten: 'Змодельовано на сервері — нічого не записано.',
    previewChanged: 'Виділено значення, які змінилися б.'
  },
  context: {
    copySelection: 'Копіювати виділений текст'
  },
  crud: {
    create: 'Створити',
    viewDetails: 'Переглянути деталі',
    viewOrEdit: 'Переглянути або змінити',
    selected: 'вибрано',
    viewUsingVms: 'Переглянути ВМ, які використовують ресурс',
    clearSelection: 'Зняти виділення',
    deleteSelected: 'Видалити вибрані',
    bulkConfirmBody: {
      one: 'Видалити {count} вибраний елемент? Якщо він захищений, його буде позначено та збережено.',
      few: 'Видалити {count} вибрані елементи? Захищені буде позначено та збережено.',
      many: 'Видалити {count} вибраних елементів? Захищені буде позначено та збережено.',
      other: 'Видалити {count} вибраного елемента? Захищені буде позначено та збережено.'
    },
    bulkDeleted: 'видалено',
    bulkRefused: 'відхилено',
    fieldId: 'ID',
    createdAt: 'Створено',
    updatedAt: 'Оновлено',
    immutableField: 'Задається під час створення — контракт не дозволяє це змінювати',
    immutableScope: 'Скоуп призначається під час створення; деякі ресурси переміщуються окремою дією',
    observedField: 'Спостережений стан — повідомляється платформою, не редагується'
  }
}
